import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "image-preview-wrapper" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]

import { ref, onMounted, onUnmounted } from 'vue'

interface Props {
  src: string
  alt?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImagePreview',
  props: {
    src: {},
    alt: {}
  },
  setup(__props: any) {

const props = __props

const isOpen = ref(false)

const openPreview = () => {
  isOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closePreview = () => {
  isOpen.value = false
  document.body.style.overflow = ''
}

const handleKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && isOpen.value) {
    closePreview()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
  document.body.style.overflow = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "thumbnail-container",
      onClick: openPreview
    }, [
      _createElementVNode("img", {
        src: __props.src,
        alt: __props.alt,
        class: "preview-image"
      }, null, 8, _hoisted_2),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"hover-overlay\" data-v-11889a47><span class=\"zoom-icon\" data-v-11889a47><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-11889a47><circle cx=\"11\" cy=\"11\" r=\"8\" data-v-11889a47></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\" data-v-11889a47></line><line x1=\"11\" y1=\"8\" x2=\"11\" y2=\"14\" data-v-11889a47></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\" data-v-11889a47></line></svg></span></div>", 1))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modern-preview-overlay",
                onClick: closePreview
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "preview-backdrop" }, null, -1)),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _withModifiers(closePreview, ["stop"])
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("line", {
                      x1: "18",
                      y1: "6",
                      x2: "6",
                      y2: "18"
                    }),
                    _createElementVNode("line", {
                      x1: "6",
                      y1: "6",
                      x2: "18",
                      y2: "18"
                    })
                  ], -1)
                ]))]),
                _createElementVNode("div", {
                  class: "preview-content",
                  onClick: closePreview
                }, [
                  _createElementVNode("img", {
                    src: __props.src,
                    alt: __props.alt,
                    class: "modal-image",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, _hoisted_3)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})